import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface DeleteScanDialogProps {
  open: boolean;
  deleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
export function DeleteScanDialog({
  open,
  deleting,
  onCancel,
  onConfirm
}: DeleteScanDialogProps) {
  return <AnimatePresence data-id="element-141" data-mp="3ue327f33346s">
      {open && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm" data-id="element-142" data-mp="3ud08z0iagpnp">
          <motion.div role="alertdialog" aria-modal="true" aria-labelledby="delete-title" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-sm border border-white/10 bg-[#0a0a0a] p-6" data-id="element-143" data-mp="3q9v975plf22r">
            <h2 id="delete-title" className="text-lg font-black uppercase tracking-tight text-white" data-id="element-144" data-mp="19nkffxroqmud">
              Delete case file?
            </h2>
            <p className="mt-2 text-sm text-gray-400" data-id="element-145" data-mp="1yhsd8irde47c">
              This permanently removes the analysis and its evidence. It can’t be undone.
            </p>
            <div className="mt-6 flex gap-3" data-id="element-146" data-mp="1olz130hkccq3">
              <button type="button" onClick={onCancel} className="min-h-[44px] flex-1 border border-white/15 text-sm font-bold uppercase tracking-wider text-gray-200 transition-colors duration-150 ease-out hover:border-white/30" data-id="element-147" data-mp="1on0g1g1p9jd3">
                Cancel
              </button>
              <button type="button" onClick={onConfirm} disabled={deleting} className="min-h-[44px] flex-1 bg-[#E10600] text-sm font-bold uppercase tracking-wider text-white transition-colors duration-150 ease-out hover:bg-[#FF1A12] disabled:opacity-70" data-id="element-148" data-mp="27kbeiyfic8rh">
                {deleting ? 'Deleting…' : 'Delete'}
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}